function DarkModeIsActive() {
    const supportsDarkMode = window.matchMedia("(prefers-color-scheme: dark)").matches;
    return supportsDarkMode
}
export default DarkModeIsActive